import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainID() {
  const articleData = {
    title: 'Mengapa Beberapa Orang Membuat Kita Merasa Terkuras? (AI Menjelaskannya)',
    description: 'Merasa terkuras secara emosional karena teks? Pelajari bagaimana AI Toxic Detector mendeteksi komunikasi sepihak dan pola pengurasan emosi halus dalam hubungan Anda.',
    slug: 'emotional-drain-relationships-ai',
    publishDate: '2025-09-03',
    author: 'Editorial Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Apa itu pengurasan emosi dalam hubungan?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Pengurasan emosi terjadi ketika interaksi dengan seseorang secara konsisten membuat Anda merasa lelah, frustrasi, atau bersalah, seringkali karena komunikasi sepihak atau manipulatif.'
      }
    }, {
      '@type': 'Question',
      name: 'Bagaimana SMS bisa menyebabkan pengurasan emosi?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Pesan sepihak yang berulang, rasa bersalah, keterlibatan yang tidak konsisten, atau kritik halus dapat membuat Anda lelah, bahkan tanpa konflik besar.'
      }
    }, {
      '@type': 'Question',
      name: 'Bisakah AI mendeteksi siapa yang menguras energi emosional saya?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya. Toxic Detector menganalisis pola teks, nada, dan keterlibatan untuk menyoroti perilaku sepihak, manipulatif, atau menguras secara instan.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    },
    datePublished: articleData.publishDate,
    dateModified: articleData.publishDate,
    url: `https://toxicdetector.com/id/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Tautan disalin ke papan klip!');
    }
  };
  return <>
      <MetaTags title="Mengapa Beberapa Orang Membuat Kita Merasa Terkuras? — AI Menjelaskan Pengurasan Emosi | ToxicDetector" description="Merasa terkuras secara emosional karena teks? Pelajari bagaimana AI Toxic Detector mendeteksi komunikasi sepihak dan pola pengurasan emosi halus." keywords="pengurasan emosi dalam hubungan, pola teks sepihak, vampir energi, analisis emosional AI" canonical={`https://toxicdetector.com/id/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/dA7JvMmr79gFQy3nZ9PyWw/file_00000000ee5472468a16f1060b3742e2.png" schema={[faqSchema, articleSchema]} data-id="element-7020" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-7021">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-7022">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-7023">
            <div className="flex items-center justify-between" data-id="element-7024">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-7025">
                <span className="text-2xl" data-id="element-7026">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-7027">
                  ToxicDetector
                </span>
              </Link>
              <div className="flex items-center gap-3" data-id="element-7028">
                <Link to="/signup" className="hidden sm:inline-block bg-red-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-red-700 transition-all shadow-sm hover:shadow-md" data-id="element-7029">
                  Pindai Gratis
                </Link>
                <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Bagikan artikel" data-id="element-7030">
                  <Share2 size={20} className="text-gray-600" data-id="element-7031" />
                </button>
              </div>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-7032">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-7033">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-7034" />
            Kembali ke Beranda
          </Link>

          <header className="mb-16" data-id="element-7035">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-7036">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-7037">
              <time dateTime={articleData.publishDate} data-id="element-7038">
                {new Date(articleData.publishDate).toLocaleDateString('id-ID', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-7039">•</span>
              <span data-id="element-7040">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-16" data-id="element-7041">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ajgMhQjEKnfJfWgPd5sqFq/1763122862210.jpg" alt="AI menganalisis pola pengurasan emosi dalam pesan teks" className="w-full rounded-2xl shadow-lg" data-id="element-7042" />
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 mb-16" data-id="element-7043">
            <h2 className="font-bold text-xl mb-6 text-gray-900" data-id="element-7044">Daftar Isi</h2>
            <ol className="space-y-3.5 text-base list-decimal list-inside" data-id="element-7045">
              <li data-id="element-7046">
                <a href="#always-something-wrong" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7047">
                  Teman "Selalu Ada yang Salah"
                </a>
              </li>
              <li data-id="element-7048">
                <a href="#only-when-they-need" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7049">
                  Orang yang Hanya Mengirim Pesan Saat Butuh Sesuatu
                </a>
              </li>
              <li data-id="element-7050">
                <a href="#dry-texting" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7051">
                  "Dry-Texter" Emosional
                </a>
              </li>
              <li data-id="element-7052">
                <a href="#ghost-return" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7053">
                  Artis Ghost & Return
                </a>
              </li>
              <li data-id="element-7054">
                <a href="#guilt-tripper" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7055">
                  Pembuat Rasa Bersalah Halus
                </a>
              </li>
              <li data-id="element-7056">
                <a href="#faux-supporter" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7057">
                  Pendukung Palsu
                </a>
              </li>
              <li data-id="element-7058">
                <a href="#healthy-toxic-combo" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7059">
                  Kombo "Sehat-Beracun"
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-7060">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-7061">
              Pernah mengirim pesan kepada seseorang dan merasa lelah, kesal,
              atau anehnya bersalah sesudahnya, bahkan jika percakapan itu bukan
              pertengkaran? Itu adalah{' '}
              <strong className="text-gray-900" data-id="element-7062">
                pengurasan emosi dalam hubungan
              </strong>
              , dan itu lebih umum daripada yang Anda pikirkan.
            </p>
            <p className="mb-16 text-lg leading-relaxed text-gray-600" data-id="element-7063">
              Itu adalah{' '}
              <strong className="text-gray-900" data-id="element-7064">pola teks sepihak</strong> dan
              manipulasi halus.{' '}
              <strong className="text-gray-900" data-id="element-7065">Analisis AI</strong> kami
              membaca pola-pola ini secara instan.
            </p>

            <section id="always-something-wrong" className="mb-16" data-id="element-7066">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7067">
                1️⃣ Teman "Selalu Ada yang Salah"
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7068">
                Anda memeriksa ponsel Anda dan langsung merasa:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-7069">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-7070">
                  "Ya Tuhan... apa lagi sekarang?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7071">
                Setiap pesan adalah stres, kekacauan, atau keluhan. AI menandai
                ini sebagai{' '}
                <strong className="text-gray-900" data-id="element-7072">
                  beban emosional sepihak
                </strong>
                .
              </p>
            </section>

            <section id="only-when-they-need" className="mb-16" data-id="element-7073">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7074">
                2️⃣ Orang yang Hanya Mengirim Pesan Saat Butuh Sesuatu
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-7075">
                <p className="mb-4 text-lg text-gray-700" data-id="element-7076">
                  <strong className="text-gray-900" data-id="element-7077">Tidak pernah:</strong> "Apa
                  kabar?"
                </p>
                <p className="text-lg text-gray-700" data-id="element-7078">
                  <strong className="text-gray-900" data-id="element-7079">Selalu:</strong> "Bisakah
                  kamu...?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7080">
                AI mendeteksi ini sebagai{' '}
                <strong className="text-gray-900" data-id="element-7081">
                  komunikasi transaksional
                </strong>
                .
              </p>
            </section>

            <section id="dry-texting" className="mb-16" data-id="element-7082">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7083">
                3️⃣ "Dry-Texter" Emosional
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-7084">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-7085">
                  "ok."
                  <br data-id="element-7086" />
                  "K."
                  <br data-id="element-7087" />
                  "👍"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-7088">
                AI menangkap{' '}
                <strong className="text-gray-900" data-id="element-7089">sinyal pemutusan</strong> ini
                secara instan.
              </p>
            </section>

            <section id="ghost-return" className="mb-16" data-id="element-7090">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7091">
                4️⃣ Artis Ghost & Return
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7092">
                Menghilang selama 3 minggu. Kembali seperti:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-7093">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-7094">
                  "haaaai 😁"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7095">
                AI menandai ini sebagai{' '}
                <strong className="text-gray-900" data-id="element-7096">
                  keterlibatan yang tidak konsisten
                </strong>
                .
              </p>
            </section>

            <section id="guilt-tripper" className="mb-16" data-id="element-7097">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7098">
                5️⃣ Pembuat Rasa Bersalah Halus
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-7099">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-7100">
                  "Kurasa aku akan pergi sendiri saja..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-7101">
                AI menandai ini sebagai{' '}
                <strong className="text-gray-900" data-id="element-7102">manipulasi pasif</strong>.
              </p>
            </section>

            <section id="faux-supporter" className="mb-16" data-id="element-7103">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7104">
                6️⃣ Pendukung Palsu
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-7105">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-7106">
                  "Maksudku, kamu memang cenderung bereaksi berlebihan
                  kadang-kadang."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7107">
                AI mendeteksi{' '}
                <strong className="text-gray-900" data-id="element-7108">kritik terselubung</strong>.
              </p>
            </section>

            <section id="healthy-toxic-combo" className="mb-16" data-id="element-7109">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7110">
                7️⃣ Kombo "Sehat-Beracun"
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-7111">
                <p className="mb-4 text-lg text-gray-700" data-id="element-7112">
                  Beberapa hari hangat. Beberapa hari dingin.
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-7113">
                AI melabeli pola ini sebagai{' '}
                <strong className="text-gray-900" data-id="element-7114">
                  ritme emosional yang tidak stabil
                </strong>
                .
              </p>
            </section>

            <section className="mb-16" data-id="element-7115">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7116">
                Mengapa Ini Penting
              </h2>
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-10 mb-10 border border-red-100" data-id="element-7117">
                <p className="font-bold mb-8 text-2xl text-gray-900" data-id="element-7118">
                  Setelah Anda melihat polanya, Anda dapat:
                </p>
                <ul className="space-y-5" data-id="element-7119">
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-7120">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-7121">
                      ✓
                    </span>
                    <span data-id="element-7122">Melindungi energi Anda</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-7123">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-7124">
                      ✓
                    </span>
                    <span data-id="element-7125">Menetapkan batasan</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-7126">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-7127">
                      ✓
                    </span>
                    <span data-id="element-7128">Berhenti merasa bersalah</span>
                  </li>
                </ul>
              </div>
            </section>

            <section id="faq" className="mb-20" data-id="element-7129">
              <h2 className="text-4xl font-bold mb-10 tracking-tight text-gray-900" data-id="element-7130">
                Pertanyaan yang Sering Diajukan
              </h2>
              <div className="space-y-5" data-id="element-7131">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-7132">
                    <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-7133">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-lg" data-id="element-7134">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl" data-id="element-7135">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-7136">
              😮‍💨 Berhenti Merasa Terkuras.
              <br data-id="element-7137" />
              Mulai Melihat dengan Jelas.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-7138">
              Berhenti menebak. Unggah teks Anda ke Toxic Detector dan dapatkan
              skor toksisitas instan.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-10 border border-white/20" data-id="element-7139">
              <p className="font-bold text-2xl" data-id="element-7140">
                "⚠️ Pengurasan Emosi: Tinggi. Komunikasi sepihak terdeteksi."
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-7141">
              Pindai Obrolan Anda Sekarang →
            </Link>
          </div>

          <div className="mt-20" data-id="element-7142">
            <RelatedBlogPosts posts={[{
            title: 'Mengapa Beberapa Orang Membuat Kita Merasa Terkuras? Bagian 2',
            description: 'Pola yang lebih halus yang menguras energi Anda, termasuk penjelasan berlebihan dan sok tahu.',
            slug: 'emotional-drain-part-2',
            emoji: '😭'
          }, {
            title: 'Panduan Utama Teks Pasif-Agresif',
            description: 'Temukan perilaku pasif-agresif dan manipulasi tersembunyi dalam pesan teks.',
            slug: 'ultimate-guide-passive-aggressive-texts',
            emoji: '😤'
          }]} data-id="element-7143" />
          </div>

          <div className="mt-16 text-center" data-id="element-7144">
            <button onClick={handleShare} className="inline-flex items-center gap-2 text-gray-700 hover:text-red-600 font-semibold transition-colors px-6 py-3 rounded-lg hover:bg-gray-50" data-id="element-7145">
              <Share2 size={20} data-id="element-7146" />
              Bagikan artikel ini
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-7147">
          <div className="max-w-4xl mx-auto px-6" data-id="element-7148">
            <div className="border-t border-gray-800 pt-8 text-center" data-id="element-7149">
              <p className="text-gray-400 text-sm" data-id="element-7150">
                © {new Date().getFullYear()} ToxicDetector. Hak cipta
                dilindungi undang-undang.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>;
}